import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import QuoteForm from '../Components/Contact/QuoteForm'
import ContactCard from '../Components/Contact/QuoteForm/ContactCard'
import HomeContact from '../Components/Home/HomeContact'
import MyMap from '../Components/Contact/ContactMap/MyMap'



const ContactUs = () => {
  const baseUrl: string = `${process.env.REACT_APP_URL}`

  return (
    <div className="bg-image">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact Us</title>
        <link rel="canonical" href={baseUrl + '/contact-us'} />
      </Helmet>
      <div className="W-100-P flex-row-wrap-space-evenly">
        <ContactCard /> 
        <QuoteForm />  
      </div>
      <div className="bg-image">
        <HomeContact />
      </div>
    </div>
  )
}
export default ContactUs

